import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, Controller } from 'swiper/modules'
import { app } from '../utils/store'
import { media } from '../utils/media';

import each from 'lodash/each'

export default class Carousel {
    constructor({ element }) {
        this.element = element

        this.createCarousel()
    }

    createCarousel() {
        const isGalleryCarousel = this.element.getAttribute('data-carousel') === 'gallery'
        const isStoreCarousel = this.element.getAttribute('data-carousel') === 'gallery-store'
        const isRoomsCarousel = this.element.getAttribute('data-carousel') === 'gallery-rooms'
        const isCompositionsCarousel = this.element.getAttribute('data-carousel') === 'gallery-compositions'
        const isInspirationsCarousel = this.element.getAttribute('data-carousel') === 'gallery-inspirations'
        const isRelatedCarousel = this.element.getAttribute('data-carousel') === 'gallery-related'
        const isVideoCarousel = this.element.getAttribute('data-carousel') === 'video'
        const isDetailsCarousel = this.element.getAttribute('data-carousel') === 'details'
        const isTabsCarousel = this.element.getAttribute('data-carousel') === 'tabs'
        const isStatusbarPromo = this.element.getAttribute('data-carousel') === 'statusbar-promo'
        const isHouseCarousel = this.element.getAttribute('data-carousel') === 'house'

        if (isGalleryCarousel) {
            // Crea il carousel se siamo sopra iPadPortrait
            if(media('>=iPadPortrait')) {
                this.createSwiper();
            }
            
            // Aggiungi callback per gestire i cambiamenti di breakpoint
            media('>=iPadPortrait', null, (matches) => {
                if (matches && !this.carousel) {
                    this.createSwiper();
                } else if (!matches && this.carousel) {
                    this.destroySwiper();
                }
            });
        }

        if (isVideoCarousel && !app.device.mobile) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: 20,
                        centeredSlides: true,
                    },
                },
                autoHeight: false,
            })
        }

        if (isStatusbarPromo) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 'auto',
                //centeredSlides: true,
                //centerInsufficientSlides: true,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                },
                loop: true,
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
            })
        }

        if (isStoreCarousel) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay],
                speed: 4000,
                slidesPerView: 1,
                spaceBetween: 10,
                // If we need pagination
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                //     type: 'bullets'
                // },
                autoplay: {
                    delay: 3000,
                },

                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: 10
                    },
                },
                autoHeight: true,
            })
        }

        if (isRoomsCarousel) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay],
                speed: 4000,
                slidesPerView: 1.4,
                centeredSlides: true,
                spaceBetween: 20,
                initialSlide: 1,
                // If we need pagination
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                //     type: 'bullets'
                // },
                // autoplay: {
                //     delay: 3000,
                // },

                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: false,
                    },
                },
                autoHeight: false,
            })
        }

        if (isCompositionsCarousel) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 1.4,
                centeredSlides: true,
                centerInsufficientSlides: true,
                spaceBetween: 0,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                // autoplay: {
                //     delay: 3000,
                // },
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        centeredSlides: false,
                        spaceBetween: 20,
                    },
                },
                autoHeight: false,
            })
        }

        if (isInspirationsCarousel && !app.device.mobile) {
            let images = this.element.querySelectorAll('img')

            each(images, (entry) => {
                entry.src = app.webp === true ? entry.getAttribute('data-webp') : entry.getAttribute('data-src')
                entry.onload = () => { entry.setAttribute('loaded', '') }

            })

            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                // autoplay: {
                //     delay: 3000,
                // },
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        centeredSlides: false,
                    },
                },
                autoHeight: false,
            })
        }

        if (isRelatedCarousel) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 1.4,
                centeredSlides: false,
                spaceBetween: 20,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                // autoplay: {
                //     delay: 3000,
                // },
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 40,
                        centeredSlides: false,
                    },
                },
                autoHeight: false,
            })
        }

        if (isDetailsCarousel) {
            let images = this.element.querySelectorAll('img')

            each(images, (entry) => {
                entry.src = app.webp === true ? entry.getAttribute('data-webp') : entry.getAttribute('data-src')
                entry.onload = () => { entry.setAttribute('loaded', '') }

            })

            this.carousel = new Swiper(this.element, {
                modules: [Pagination, Navigation, Controller],
                speed: 500,
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                rewind: false,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    // nextEl: this.element.querySelector("[data-next]"),
                    // prevEl: this.element.querySelector("[data-prev]"),
                    nextEl: app.statusbar.querySelector("[data-next]"),
                    prevEl: app.statusbar.querySelector("[data-prev]"),
                    clickable: true,
                },
                pagination: {
                    type: "bullets",
                    el: app.statusbar.querySelector("[data-pagination]"),
                    clickable: true,
                    dynamicBullets: true,
                },
                // autoplay: {
                //     delay: 3000,
                // },
                autoHeight: true,
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: false,
                        loop: true,
                        loopAdditionalSlides: 3,
                        autoHeight: true,
                    },
                },
                on: {
                    init: (carousel) => {
                        if (carousel.navigation.nextEl && carousel.activeIndex == 0) {
                            carousel.navigation.nextEl.classList.add('active')
                        } else if (carousel.navigation.nextEl) {
                            carousel.navigation.nextEl.classList.remove('active')
                        }
                    },
                    activeIndexChange: (carousel) => {
                        if (carousel.navigation.nextEl && carousel.activeIndex == 0) {
                            carousel.navigation.nextEl.classList.add('active')
                        } else if (carousel.navigation.nextEl) {
                            carousel.navigation.nextEl.classList.remove('active')
                        }
                    }
                }
            })

            // this.controls = new Swiper(this.element, {
            //     modules: [Navigation, Controller],
            //     navigation: {
            //         nextEl: app.statusbar.querySelector("[data-next]"),
            //         prevEl: app.statusbar.querySelector("[data-prev]"),
            //         clickable: true,
            //     },
            // })

            // this.controls.controller.control = this.carousel
        }

        if (isTabsCarousel && !app.device.mobile) {
            let images = this.element.querySelectorAll('img')

            each(images, (entry) => {
                entry.src = app.webp === true ? entry.getAttribute('data-webp') : entry.getAttribute('data-src')
                entry.onload = () => { entry.setAttribute('loaded', '') }

            })

            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                // autoplay: {
                //     delay: 3000,
                // },
                centerInsufficientSlides: false,
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        centeredSlides: false,
                    },
                },
                autoHeight: false,
            })
        }

        if (isHouseCarousel) {
            let images = this.element.querySelectorAll('img')
    
            each(images, (entry) => {
                entry.src = app.webp === true ? entry.getAttribute('data-webp') : entry.getAttribute('data-src')
                entry.onload = () => { entry.setAttribute('loaded', '') }
            })
    
            this.carousel = new Swiper(this.element, {
                modules: [Pagination, Navigation, Controller],
                speed: 500,
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                rewind: false,
                // initialSlide: 1,
                // If we need pagination
                navigation: {
                    // nextEl: this.element.querySelector("[data-next]"),
                    // prevEl: this.element.querySelector("[data-prev]"),
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                // pagination: {
                //     type: "bullets",
                //     el: app.statusbar.querySelector("[data-pagination]"),
                //     clickable: true,
                //     dynamicBullets: true,
                // },
                // autoplay: {
                //     delay: 3000,
                // },
                autoHeight: true,
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: false,
                        // autoHeight: false,
                    },
                },
                on: {
                    init: (carousel) => {
                        if (carousel.navigation.nextEl && carousel.activeIndex == 0) {
                            carousel.navigation.nextEl.classList.add('active')
                        } else if (carousel.navigation.nextEl) {
                            carousel.navigation.nextEl.classList.remove('active')
                        }
                    },
                    activeIndexChange: (carousel) => {
                        if (carousel.navigation.nextEl && carousel.activeIndex == 0) {
                            carousel.navigation.nextEl.classList.add('active')
                        } else if (carousel.navigation.nextEl) {
                            carousel.navigation.nextEl.classList.remove('active')
                        }
                    }
                }
            })
    
            // this.controls = new Swiper(this.element, {
            //     modules: [Navigation, Controller],
            //     navigation: {
            //         nextEl: app.statusbar.querySelector("[data-next]"),
            //         prevEl: app.statusbar.querySelector("[data-prev]"),
            //         clickable: true,
            //     },
            // })
    
            // this.controls.controller.control = this.carousel
        }
    }

    createSwiper() {
        if (!this.carousel) {
            this.carousel = new Swiper(this.element, {
                modules: [Autoplay, Navigation],
                speed: 500,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.element.querySelector("[data-next]"),
                    prevEl: this.element.querySelector("[data-prev]"),
                    clickable: true,
                },
                centerInsufficientSlides: true,
                autoHeight: false,
            })
        }
    }

    destroySwiper() {
        if (this.carousel) {
            this.carousel.destroy(true, true);
            this.carousel = null;
        }
    }
}